/* eslint-disable */
import trackGTMEvents from '../trackGTMEvents/new';
import { setItem, getItem, deleteItem } from '../localStorage';

const lmMap = {
  1: 'facebook',
  2: 'google',
  3: 'email',
  4: 'apple',
  6: 'googleonetap',
};

const lmTrackMap = {
  1: 'Facebook',
  2: 'Google',
  3: 'Email',
  4: 'Apple',
  6: 'GoogleOneTap',
};

const mediumListCleanUp = (signinData) => {
  const safeData = JSON.parse(JSON.stringify(signinData));
  const { lastSession: { medium } } = safeData;
  const cleanMediumList = medium.filter(Boolean);
  safeData.lastSession.medium = cleanMediumList;
  return safeData;
};

const formDataCleanUp = (original) => {
  if (!original) {
    return null;
  }
  const clean = JSON.parse(JSON.stringify(original));
  if (clean.firstName && !clean.name) {
    clean.name = clean.firstName;
  }
  delete clean.firstName;
  delete clean.lastName;
  return clean;
};

const excludeCEmailFromFormData = (original) => {
  const formData = {};
  Object.keys(original).forEach((k) => {
    if (k !== 'cEmail') {
      formData[k] = original[k];
    }
  });
  return formData;
}

export default function ({
  login = false,
  track = false,
  logout = false,
  updateFormData = false,
  trackOneTapPrompt = false,
  medium = null,
  email = null,
  timeStamp = null,
  formData = {},
  from = null,
  newUser = false,
}) {
  const isOneTap = (medium || 0).toString() === '6';
  const signinData = getItem('signinData') || {
    lastSession: {
      medium: [],
      lastLoginMedium: '',
      loginTs: 0,
    },
    formData: formDataCleanUp(getItem('formData')) || {},
    oneTapPrompt: false,
  };

  if (login && timeStamp !== signinData?.lastSession?.loginTs) {
    if (track && isOneTap) {
      trackGTMEvents({
        category: 'User',
        action: newUser ? 'SignUp' : 'Login',
        ...from && { from },
        label: lmTrackMap[medium],
      }, null, true);
    }
    const newMediumVal = signinData.lastSession.medium.indexOf(lmMap[medium]) < 0
      ? [...signinData.lastSession.medium, lmMap[medium]]
      : signinData.lastSession.medium;

    signinData.lastSession = {
      ...signinData.lastSession,
      medium: newMediumVal,
      lastLoginMedium: lmMap[medium],
      email,
      loginTs: timeStamp,
    };

    signinData.formData = excludeCEmailFromFormData(formDataCleanUp({
      ...signinData.formData,
      ...formData,
    }));
  } else if (logout) {
    const lsKey = Object.keys(lmTrackMap).filter((m) => lmTrackMap[m].toLowerCase() === signinData.lastSession.lastLoginMedium)[0] || 3;
    trackGTMEvents({
      category: 'User',
      action: 'Logout',
      label: lmTrackMap[lsKey],
    }, null, true);

    signinData.lastSession = {
      ...signinData.lastSession,
      logoutTs: new Date().getTime(),
    };

    signinData.formData = excludeCEmailFromFormData(signinData.formData);
  } else if (updateFormData) {
    signinData.formData = formDataCleanUp({
      ...signinData.formData,
      ...formData,
    });
  } else if (trackOneTapPrompt) {
    signinData.oneTapPrompt = true;
  }
  const result = mediumListCleanUp(signinData);
  setItem('signinData', result);
  deleteItem('favorites');

  if (login && isOneTap) {
    return { isOneTap, signinData: result };
  }

  return null;
}
